import { render, staticRenderFns } from "./VideoItems2Template.vue?vue&type=template&id=7c4cf816"
import script from "./VideoItems2Template.vue?vue&type=script&lang=js"
export * from "./VideoItems2Template.vue?vue&type=script&lang=js"
import style0 from "./VideoItems2Template.vue?vue&type=style&index=0&id=7c4cf816&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports